import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import "./ContactWarranty.css";


const ContactWarrantySection = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const validatePhoneNumber = (phone) => {
    const phonePattern =
      /^(\+1|1)?\s?(\(\d{3}\)|\d{3})[\s\-]?\d{3}[\s\-]?\d{4}$/;
    return phonePattern.test(phone);
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, phone, email, subject, message } = formData;

    if (
      !name.trim() ||
      !phone.trim() ||
      !email.trim() ||
      !subject.trim() ||
      !message.trim()
    ) {
      toast.error("All fields are required!", { position: "top-right" });
      return;
    }

    if (!validatePhoneNumber(phone)) {
      toast.error("Please enter a valid Canadian phone number.", {
        position: "top-right",
      });
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address.", {
        position: "top-right",
      });
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          toast.success(
            "Success! We’ve received your message and will respond soon.",
            {
              position: "top-right",
            }
          );
          setFormData({
            name: "",
            phone: "",
            email: "",
            subject: "",
            message: "",
          });
        },
        (error) => {
          toast.error(
            "Message not sent. Please retry or contact support if the issue persists.",
            {
              position: "top-right",
            }
          );
        }
      );
  };
  return (
    <div className="container my-5">
      <div className="row g-4  justify-content-center">
        <div className="col-md-6">
          <div className="contact-card p-4 rounded shadow" data-sal='slide-up' data-sal-duration="2000" data-sal-delay="300">
            <h2
              className="text-white text-center fw-bold mb-2"
              style={{ fontWeight: "bold", fontSize: "40px" }}
            >
              Get in Touch
            </h2>
            <p
              className="text-white text-center mb-4"
              style={{ fontWeight: "bold" }}
            >
              Ready to start your renovation project? Contact us today for a
              free quote and consultation.
            </p>
            <form ref={formRef} onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label text-white">Name :</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label text-white">Email:</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label text-white">Phone:</label>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Enter phone number"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <div className="mb-3">
                  <label className="form-label text-white">Subject :</label>
                  <select
                    name="subject"
                    className="form-select"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Your Service</option>
                    <option value="Kitchen Renovations">
                      Kitchen Renovations
                    </option>
                    <option value="Bathroom Renovations">
                      Bathroom Renovations
                    </option>
                    <option value="Basement Renovations">
                      Basement Renovations
                    </option>
                    <option value="Home Extensions">Home Extensions</option>
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label text-white">Message:</label>
                <textarea
                  className="form-control"
                  rows="3"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your message "
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="btn btn-dark w-100 fw-bold text-war"
                style={{ textTransform: "uppercase" }}
              >
                Get Quote Now
              </button>
            </form>
          </div>
        </div>

        {/* Right: Warranty */}
        {/* <div
          className="col-md-6 text-center warranty-card p-4 border rounded"
          style={{ minHeight: "400px", maxWidth: "500px", margin: "0 auto" }}
        >
          <img
            src={warrantyLogo}
            alt="10 Year Warranty"
            style={{ maxWidth: 120 }}
            className="mb-3"
          />
          <h2 className="fw-bold text-war text-center">10-YEAR UNLIMITED WARRANTY</h2>
          <p
            className="mt-3 text-dark"
            style={{ color: "black", fontSize: "20px", fontWeight: "400" }}
          >
            We stand by our work with a 10-year unlimited warranty on all
            projects.
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default ContactWarrantySection;
